/**
 * index for component base
 */
export * from './component-base';
export * from './component-decorator';
export * from './template';
